import { useMessageStats } from "../hooks/useData";

const pageTitles = {
  home:     "Tableau de bord",
  messages: "Messages",
  support:  "Support client",
  contacts: "Contacts",
  relances: "Relances",
  settings: "Paramètres",
};

export default function Topbar({ currentPage, sidebarOpen, setSidebarOpen, isMobile }) {
  const { stats } = useMessageStats();

  const getMsgBg = () => {
    if (!stats) return 'bg-gray-100 border-gray-200';
    if (stats.percentage >= 80) return 'bg-red-50 border-red-200';
    if (stats.percentage >= 60) return 'bg-amber-50 border-amber-200';
    return 'bg-green-50 border-green-200';
  };

  const getMsgColor = () => {
    if (!stats) return 'text-gray-400';
    if (stats.percentage >= 80) return 'text-red-600';
    if (stats.percentage >= 60) return 'text-amber-500';
    return 'text-green-600';
  };

  const getDot = () => {
    if (!stats) return 'bg-gray-300';
    if (stats.percentage >= 80) return 'bg-red-500';
    if (stats.percentage >= 60) return 'bg-amber-500';
    return 'bg-green-500';
  };

  const used = stats?.used?.toLocaleString() || '0';
  const limit = stats?.limit?.toLocaleString() || '...';
  const trialExpired = stats?.isTrial && stats?.hoursLeft === 0;

  return (
    <div className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {isMobile ? (
          <div className="flex items-center gap-2">
            <div style={{width:'32px',height:'32px',background:'linear-gradient(135deg,#C04828,#FF6B3D)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
              <svg width="20" height="20" viewBox="0 0 22 22" fill="none">
                <rect x="2" y="4" width="18" height="12" rx="3.5" fill="white"/>
                <path d="M8 16 L5 20 L13 16" fill="white"/>
                <circle cx="7" cy="10" r="1.4" fill="#C04828"/>
                <circle cx="11" cy="10" r="1.4" fill="#C04828"/>
                <circle cx="15" cy="10" r="1.4" fill="#C04828"/>
              </svg>
            </div>
            <h1 className="text-base font-medium text-orange-600">
              {pageTitles[currentPage]}
            </h1>
          </div>
        ) : (
          <h1 className="text-base font-medium text-gray-800">
            {pageTitles[currentPage]}
          </h1>
        )}
      </div>

      <div className="flex items-center gap-3">
        <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-xs font-medium ${
          trialExpired ? 'bg-red-50 border-red-200' : getMsgBg()
        }`}>
          <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${
            trialExpired ? 'bg-red-500' : getDot()
          }`} />
          <span className={trialExpired ? 'text-red-600' : getMsgColor()}>
            {trialExpired ? (
              isMobile ? 'Expiré' : 'Essai terminé — Choisissez un plan'
            ) : isMobile ? (
              `${used}/${limit}`
            ) : stats?.isTrial ? (
              `${used} / ${limit} · Trial — ${stats.hoursLeft}h restantes`
            ) : (
              `${used} / ${limit} messages disponibles`
            )}
          </span>
        </div>

        <button className="relative p-1.5 rounded-lg hover:bg-gray-100 transition-colors text-gray-500">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
            <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
            <path d="M13.73 21a2 2 0 01-3.46 0"/>
          </svg>
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>
      </div>
    </div>
  );
}